module.exports = __webpack_public_path__ + "10f333b6285015ad8e40665d52b733ce.pdf";